import { ENTITY_TYPE_GROUPS, INDIVIDUAL_ROW_LABEL } from '@verifime/components';
import { REQUEST_CHOOSE_SCREEN_COPY } from '@verifime/components/src/RequestScreens/RequestChooseScreen/requestChooseScreenCopy';
import { entityTypeLabel } from './entityPlan';
import type { TRequestCriteria } from './requestCriteria';

/**
 * CANDIDATE COPY, not approved: awaiting Charles's approval (verifime-adr#637, W30).
 *
 * What an unrestricted request asks for. The rulings give no string for "nothing limits the
 * choice", so this is the candidate words. They complete the request header ("<provider> Asks for
 * <label>") for a request that names no entity type.
 */
export const UNRESTRICTED_ASKS_LABEL = 'Any identity';

/**
 * What a request asks for, as the request choose screen's header names it: the as-built label of
 * an exact type, the group title of a group, the screen's candidate words for any organisation.
 * An unrestricted request uses its candidate words, `UNRESTRICTED_ASKS_LABEL`.
 *
 * `REQUEST_CHOOSE_SCREEN_COPY` is deep-imported, as the request choose view does for its other
 * copy: the components index exports the limit note only.
 */
export function criteriaAsksLabel(criteria: TRequestCriteria): string {
  switch (criteria.kind) {
    case 'exact':
      return criteria.entityType === 'individual'
        ? INDIVIDUAL_ROW_LABEL
        : entityTypeLabel(criteria.entityType);
    case 'group':
      return ENTITY_TYPE_GROUPS[criteria.group].title;
    case 'any-organisation':
      return REQUEST_CHOOSE_SCREEN_COPY.anyNonIndividual;
    case 'unrestricted':
      return UNRESTRICTED_ASKS_LABEL;
  }
}
